export default __webpack_public_path__ + "afcee08a7836cee7403eb1124d495e81.jpg";